module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "MsgSlide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageShow),
      expression: "messageShow"
    }],
    staticClass: "MessageCom"
  }, [_c('div', {
    staticClass: "MessageIcon"
  }, [_vm._v("i")]), _vm._v(" "), _c('p', {
    staticClass: "MessageInfo"
  }, [_vm._v(_vm._s(_vm.sendMessage))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11c4b47a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Message/Message.vue
// module id = 257
// module chunks = 1